import { render, staticRenderFns } from "./InvalidGoods.vue?vue&type=template&id=71786125&scoped=true&"
import script from "./InvalidGoods.vue?vue&type=script&lang=ts&"
export * from "./InvalidGoods.vue?vue&type=script&lang=ts&"
import style0 from "./InvalidGoods.vue?vue&type=style&index=0&id=71786125&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71786125",
  null
  
)

export default component.exports